var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3H3.75C2.09315 3 0.75 4.34315 0.75 6V18C0.75 19.6569 2.09315 21 3.75 21H20.25C21.9069 21 23.25 19.6569 23.25 18V6C23.25 4.34315 21.9069 3 20.25 3Z",
    fill: "#071B65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82575 3H3.75C2.26425 3 1.03875 4.083 0.800251 5.5005L20.1743 21H20.25C21.7358 21 22.9613 19.917 23.1998 18.4995L3.82575 3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 14.25H14.8125L22.263 20.2103C22.5533 19.9455 22.791 19.6275 22.9598 19.2675L16.6875 14.25Z",
    fill: "#B92932"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04025 4.73175L7.3125 9.75H9.1875L1.737 3.78975C1.44675 4.0545 1.209 4.37175 1.04025 4.73175Z",
    fill: "#B92932"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 21H3.82575L23.1998 5.5005C22.9613 4.08225 21.7358 3 20.25 3H20.1743L0.800251 18.4995C1.03875 19.9177 2.26425 21 3.75 21Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3H9.75V21H14.25V3Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 9.75H0.75V14.25H23.25V9.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3H10.5V21H13.5V3Z",
    fill: "#B92932"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 13.5V10.5L0.75 10.5V13.5L23.25 13.5Z",
    fill: "#B92932"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1665 3.1575L14.25 8.6895V9.75H14.8125L22.2698 3.795C21.9555 3.507 21.5813 3.29175 21.1665 3.1575Z",
    fill: "#B92932"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.746 20.2178C2.0565 20.4983 2.424 20.7097 2.83125 20.8417L9.75 15.3068V14.2507H9.1875L1.746 20.2178Z",
    fill: "#B92932"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.25 3H3.75C2.09325 3 0.75 4.34325 0.75 6V18C0.75 19.6567 2.09325 21 3.75 21H20.25C21.9067 21 23.25 19.6567 23.25 18V6C23.25 4.34325 21.9067 3 20.25 3ZM22.5 18C22.5 19.2405 21.4905 20.25 20.25 20.25H3.75C2.5095 20.25 1.5 19.2405 1.5 18V6C1.5 4.7595 2.5095 3.75 3.75 3.75H20.25C21.4905 3.75 22.5 4.7595 22.5 6V18Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.25 3.75H3.75C2.50725 3.75 1.5 4.75725 1.5 6V6.75C1.5 5.50725 2.50725 4.5 3.75 4.5H20.25C21.4928 4.5 22.5 5.50725 22.5 6.75V6C22.5 4.75725 21.4928 3.75 20.25 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.856b4cb7c044c0c923323f34dfef6803.svg";
export { ForwardRef as ReactComponent };